export default function ErrorPage(props) {

    return (
        <>
            <div>404 | Page Not Found</div>
        </>
    )
}